<template>
  <div class="mrz-data-container">
    <mrz-heading :is-mrz-verified-success-icon="isMrzVerifiedSuccessIcon" />
    <mrz-lines-container
      v-if="!!mrzVerifiedRule"
      :current-identification="currentIdentification"
      :document-updating="documentUpdating"
      :is-document-edit-enabled="isDocumentEditEnabled"
      :field-values="fieldValues"
      :action-in-progress="actionInProgress"
      @field-change="$emit('field-change', $event)"
    />
    <div v-else>
      {{ $t("mrz_does_not_exist") }}
    </div>
  </div>
</template>

<script>
import { CHECK_STATUS } from "@/router/constants";
import { IDENTIFICATION_RULES } from "../../constants/document";
import MrzHeading from "./MrzHeading";
import MrzLinesContainer from "./MrzLinesContainer";

export default {
  props: {
    documentUpdating: { type: Boolean, default: false },
    currentIdentification: { type: Object, default: null },
    isDocumentEditEnabled: { type: Boolean, default: false },
    fieldValues: { type: Object, default: null },
    actionInProgress: { type: Boolean, default: false }
  },

  emits: ["field-change"],

  computed: {
    mrzVerifiedRule() {
      return this.currentIdentification?.data?.rules?.find(
        rule => rule?.name === IDENTIFICATION_RULES.MRZ_VERIFIED
      );
    },

    isMrzVerifiedSuccessIcon() {
      return (
        !this.mrzVerifiedRule ||
        this.mrzVerifiedRule?.status === CHECK_STATUS.SUCCESS
      );
    }
  },

  components: {
    MrzLinesContainer,
    MrzHeading
  }
};
</script>
<style scoped>
.mrz-data-container {
  margin: 1rem 0;
}
</style>
